import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDateBoxModule } from 'devextreme-angular';
import { ParametersComponent } from './parameters.component';
import { TabModule } from '../tab/tab.module';

@NgModule({
  declarations: [ParametersComponent],
  imports: [
    CommonModule,
    DxButtonModule,
    DxDateBoxModule,
    TabModule
  ],
  exports: [ParametersComponent]
})
export class ParametersModule { }

